<div class="tw-relative">
  <app-icon-button-new
    [additionalCssClasses]="'tw-opacity-30'"
    [backgroundColor]="'dark'"
    (click)="onFeatureFlagManagerTriggerClick()"
  >
    <app-icon [color]="'bright'" [icon]="'fasGear'" />
  </app-icon-button-new>

  @if (isOpen()) {
    <div
      class="tw-absolute tw-bottom-full tw-right-0 tw-mt-1 tw-w-[260px] tw-rounded-lg tw-border tw-border-gray-dark tw-bg-white tw-p-4"
    >
      <app-heading class="tw-mb-1 tw-block tw-font-bold" [level]="6">
        Feature flags
      </app-heading>

      <div class="tw-flex tw-flex-col tw-gap-3">
        @for (flag of flagItems(); track flag.id) {
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
            <span class="tw-text-14 tw-text-gray-very-dark">
              {{ flag.displayName }}
            </span>
            <app-checkbox
              [state]="flag.checkboxState"
              (stateChange)="onCheckboxStateChange(flag.id, $event)"
            />
          </div>
        }
      </div>

      <app-button
        class="tw-mt-4 tw-block tw-w-full"
        (click)="onSaveAndReload()"
      >
        Save & reload
      </app-button>

      <app-button
        class="tw-mt-2 tw-block tw-w-full"
        [variant]="'outlined'"
        (click)="onResetToDefaults()"
      >
        Reset to defaults
      </app-button>
    </div>
  }
</div>
